<template>
  <UIBox v-if="event" column class="asb-event-card">
    <UILoader :grow="grow" :loading="isLoading" column>
      <UIBox v-if="event" column :data-eventid="event.Id" optimized @click="onEventClick(event.Id)">
        <UIBox start column class="asb-event-card__info">
          <UIBox uncut class="asb-event-card__teams-icons">
            <UIBox
              v-for="(competitor, competitorIdx) in event.Competitors"
              :key="competitorIdx"
              class="asb-event-card__team-icon"
              :class="'TEAM_' + (competitor.Abbreviation || '')"
            ></UIBox>
          </UIBox>
          <UIBox start column class="asb-event-card-info__wrapper">
            <UIBox>
              <CLiveIndicator :grow="false" :isLive="event.IsLive" />
            </UIBox>
            <UIBox v-if="event.IsLive" class="asb-event-card__live-time">{{event.LiveState}}</UIBox>
            <UIBox class="asb-event-card__prelive-time">{{startTime}}</UIBox>
            <UIBox v-if="!event.IsLive" class="asb-event-card__prelive-date">{{startDate}}</UIBox>
            <UIBox wrap class="asb-event-card__championship">
              <UIText>{{event.Category.Name}}</UIText>
              <UIText>&nbsp;•&nbsp;</UIText>
              <UIText>{{event.Champ.Name}}</UIText>
            </UIBox>
          </UIBox>
        </UIBox>
        <CCompetitors
          class="asb-event-card__competitors"
          grow
          :competitors="event.Competitors"
          :score="score"
        />
        <UIBox grow>
          <template v-for="odd in event.Markets[0].Odds">
            <COddEventCard grow :odd="odd" :key="odd.Id" />
          </template>
        </UIBox>
      </UIBox>
    </UILoader>
  </UIBox>
</template>

<script>
import CLiveIndicator from '@/components/CLiveIndicator/CLiveIndicator.vue'
import CCompetitors from '@/components/CCompetitors/CCompetitors.vue'
import COddEventCard from '@/components/COdds/COddEventCard.vue'
import { DateFunctions, EventFunctions } from '@altenar/models'
import config from '@/config'

export default {
  name: 'CEventCard',
  props: {
    eventId: {
      type: String,
      default: ''
    },
    marketType: {
      type: String,
      default: ''
    },
    event: {
      type: Object
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    score() {
      const score = this.event.Score || ''
      return score ? score.split(':') : ''
    },
    startDate() {
      return DateFunctions.getFormattedDate(this.event.Date, 'dayMonth')
    },
    startTime() {
      return DateFunctions.getFormattedDate(this.event.Date, 'time')
    }
  },
  methods: {
    onEventClick(eventId) {
      config.callbacks.eventclick(eventId)
    }
  },
  components: { COddEventCard, CCompetitors, CLiveIndicator }
}
</script>
